import {
    defaultStoragePoolUuid,
    extremeStoragePoolUuid,
    fasterStoragePoolUuid,
} from "@/mock-api/data/adminStoragePoolExample.ts";
import type { AdminHostPool } from "@warrenio/api-spec/spec.oats.gen";

export const defaultHostPoolUuid = "d2fc6881-9316-46d7-b515-b6cddaeee927";
export const fasterHostPoolUuid = "00000000-0000-0000-0000-000167bb0a39";
export const extremeHostPoolUuid = "3590345e-0507-49d7-8e69-7fb16311a3a5";

export const adminHostPoolExample: AdminHostPool[] = [
    {
        cpu_allocate_coefficient: 3.0,
        cpu_model: "Westmere-IBRS,-spec-ctrl",
        created_at: "2022-12-28 13:50:52",
        description: "Standard storage",
        hosts_assigned_count: 52,
        is_default_designated: false,
        is_hv_auto_assigned: false,
        is_visible: true,
        mem_allocate_coefficient: 0.8,
        name: "Default",
        os_type: "linux",
        storage_pool_uuid: defaultStoragePoolUuid,
        ui_position: 0,
        updated_at: "2025-05-09 07:00:32",
        uuid: defaultHostPoolUuid,
        guest_limits: {
            cpu: { max: 8, min: 1 },
            disk_gb: { max: 500, min: 10 },
            ram_mb: { max: 32768, min: 512 },
        },
    },
    {
        cpu_allocate_coefficient: 3.0,
        cpu_model: "Westmere-IBRS,-spec-ctrl",
        created_at: "2020-09-30 11:05:56",
        description: "Performance storage",
        hosts_assigned_count: 46,
        is_default_designated: false,
        is_hv_auto_assigned: true,
        is_visible: true,
        mem_allocate_coefficient: 0.8,
        name: "Faster",
        os_type: "multi",
        storage_pool_uuid: fasterStoragePoolUuid,
        ui_position: 1,
        updated_at: "2025-04-03 11:50:25",
        uuid: fasterHostPoolUuid,
        guest_limits: {
            cpu: { max: 8, min: 1 },
            disk_gb: { max: 500, min: 10 },
            ram_mb: { max: 32768, min: 512 },
        },
    },
    {
        cpu_allocate_coefficient: 2.5,
        cpu_model: "Westmere-IBRS,-spec-ctrl",
        created_at: "2023-09-01 15:11:21",
        description: "Extreme storage",
        hosts_assigned_count: 6,
        is_default_designated: true,
        is_hv_auto_assigned: false,
        is_visible: true,
        mem_allocate_coefficient: 0.8,
        name: "Extreme",
        os_type: "multi",
        storage_pool_uuid: extremeStoragePoolUuid,
        ui_position: 2,
        updated_at: "2025-05-28 11:33:57",
        uuid: extremeHostPoolUuid,
        guest_limits: {
            cpu: { max: 8, min: 1 },
            disk_gb: { max: 500, min: 10 },
            ram_mb: { max: 32768, min: 512 },
        },
    },
];

export const adminHostPoolExample2: AdminHostPool[] = [
    {
        cpu_allocate_coefficient: 2.5,
        cpu_model: "RaptorCove",
        created_at: "2023-10-23 09:45:42",
        description: "High speed block storage",
        hosts_assigned_count: 0,
        is_default_designated: false,
        is_hv_auto_assigned: false,
        is_visible: true,
        mem_allocate_coefficient: 0.8,
        name: "Performance",
        os_type: "multi",
        storage_pool_uuid: "99f860fe-e055-6666-8335-5544e6597aed",
        ui_position: 0,
        updated_at: "2025-11-26 11:48:47",
        uuid: "ae2bd247-5555-4176-9b25-2693efa1014a",
        guest_limits: {
            cpu: { max: 8, min: 1 },
            disk_gb: { max: 500, min: 10 },
            ram_mb: { max: 32768, min: 512 },
        },
    },
    {
        cpu_allocate_coefficient: 2.5,
        cpu_model: "Westmere-IBRS,-spec-ctrl,-md-clear,-ssbd",
        created_at: "2020-09-30 11:05:56",
        description: "Economy compute and storage",
        hosts_assigned_count: 2,
        is_default_designated: true,
        is_hv_auto_assigned: true,
        is_visible: false,
        mem_allocate_coefficient: 0.8,
        name: "Standard",
        os_type: "multi",
        storage_pool_uuid: "99c86dfe-e055-6666-8335-5544e6597aed",
        ui_position: 2,
        updated_at: "2025-09-18 08:00:53",
        uuid: "b1823fad-7777-4062-89d7-40d02e192525",
        guest_limits: {
            cpu: { max: 8, min: 1 },
            disk_gb: { max: 500, min: 10 },
            ram_mb: { max: 32768, min: 512 },
        },
    },
];

// cspell:words ssbd Westmere
